import { add, remove } from "@fluorescent/dom";
import { delayOffset } from "@/lib/animation";

const selectors = {
  filterGroup: ".animation--filter-form-group",
};

const classes = {
  animationRevealed: "animation--filter-sidebar-revealed",
};

export default node => {
  delayOffset(node, [selectors.filterGroup]);

  // Trigger the reveal animation when the sidebar is opened
  function open() {
    add(node, classes.animationRevealed);
  }

  // Reset the reveal animation when the sidebar is closed
  function close() {
    remove(node, classes.animationRevealed);
  }

  return {
    open,
    close
  };
};
